import { Component, OnInit, OnDestroy, Input, Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { interval, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NotificationInterface } from '@core/store/models/notifications.interface';

import { NotificationsService } from '@core/services/notifications/notifications.service';


@Component({
    selector: 'core-notifications-helpers-event-version-status-update-success',
    templateUrl: './version-status-update-success.component.html',
    styleUrls: ['./version-status-update-success.component.scss']
})
export class CoreNotificationsHelpersEventVersionStatusUpdateSuccessComponent implements OnInit {

    public readonly SUCCESS_DISPLAY_TIME = 10;
    
    // EVENT_VERSION_STATUS_UPDATED_SUCCESS
    @Input() notification: NotificationInterface;
    // @Output() dismiss = new EventEmitter<NotificationInterface>();

    public time: number = this.SUCCESS_DISPLAY_TIME;
    public countdown$: Observable<number> = interval(this.SUCCESS_DISPLAY_TIME);

    constructor(private notsSrv: NotificationsService) {
    }

    ngOnInit(){
        console.log(" notification success",this.notification);
        if(this.notification != null)
            this.startCount();


        /**
         *  TODO: Here we could manage what success event it is:
         *  data property should bring needed info:
         * - version status update: we need the new status name
         * - project stage update: we need the new stage name
         * - version created:
         * - proeject created:
         * - label added: we need label name
         * - label remved:
         * etc...
         */
    }

    ngOnDestroy(): void {
    }

    // Display time control
    protected startCount(){
        this.countdown$ = interval(1000).pipe(
            map(count => { 
                this.time = this.SUCCESS_DISPLAY_TIME - count > 0 ? this.SUCCESS_DISPLAY_TIME - count : 0;
                if(this.time == 0){
                    // on count reach 0 => dismiss notification (hide) 
                    this.notsSrv.dismissNotification(this.notification.id);
                }
                return this.time;
            } )
          );
        
    }
}
